// 第三方sdk 对应后台 wxopen-proxy
import openSDK from './openSDK';
import * as configure from './configure';
import * as marketing from './marketing';
import * as order from './order';
import * as pay from './pay';
import * as shopmember from './shopmember';
import * as soyoung from './soyoung';
import * as commodity from './commodity';
import * as notify from './notify';
import * as wechat from './wechat';
import * as user from './user';
import * as sms from './sms';
import * as file from './file';
import * as common from './common';
import * as creditmall from './creditmall';
import * as delivery from './delivery';
import * as brand from './brand';
import * as mysteryBox from './mystery-box';
import * as onePlusOne from './one-plus-one';
import * as surpriseBox from './surprise-box';

export default {
  ...openSDK,
  ...configure,
  ...marketing,
  ...order,
  ...pay,
  ...shopmember,
  ...soyoung,
  ...commodity,
  ...notify,
  ...wechat,
  ...user,
  ...sms,
  ...file,
  ...common,
  ...creditmall,
  ...delivery,
  ...brand,
  ...mysteryBox,
  ...onePlusOne,
  ...surpriseBox,
};
